import type { CarStatus } from '@telega/shared';
import { STATUS_LABEL } from '@telega/shared';
import { Check } from 'lucide-react';
import { cx } from '../lib/cx';

const STATUS_CLASSES: Record<CarStatus, string> = {
  in_transit: 'bg-st-transit/14 text-st-transit',
  customs: 'bg-st-customs/14 text-st-customs',
  available: 'bg-st-available/14 text-st-available',
  reserved: 'bg-st-reserved/14 text-st-reserved',
  sold: 'bg-st-sold/14 text-st-sold',
  archived: 'bg-st-archived/14 text-st-archived',
};

/** Colored status label (docs/UI.md 2, status colors). */
export function StatusChip({
  status,
  suffix,
  className,
}: {
  status: CarStatus;
  suffix?: string;
  className?: string;
}) {
  return (
    <span
      className={cx(
        'inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-[13px] font-medium',
        STATUS_CLASSES[status],
        className,
      )}
    >
      {status === 'sold' && <Check className="size-3.5" aria-hidden />}
      {STATUS_LABEL[status]}
      {suffix && <span className="tabular-nums">{suffix}</span>}
    </span>
  );
}

interface FilterChipProps {
  label: string;
  count?: number;
  selected: boolean;
  onClick: () => void;
}

/** Selectable chip with an optional count, used by the fleet status filter. */
export function FilterChip({ label, count, selected, onClick }: FilterChipProps) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onClick}
      className={cx(
        'inline-flex h-8 shrink-0 items-center gap-1.5 rounded-full px-3 text-[15px] transition-colors',
        selected ? 'bg-button text-button-text' : 'bg-section text-text',
      )}
    >
      {label}
      {count !== undefined && (
        <span className={cx('tabular-nums text-[13px]', selected ? 'opacity-80' : 'text-hint')}>
          {count}
        </span>
      )}
    </button>
  );
}
